import React from 'react';
import { Route } from 'react-router-dom';
import HotelExtras from '../pages/hotelExtras/HotelExtras';
import CreateHotelExtra from '../pages/hotelExtras/CreateHotelExtra';
import EditHotelExtra from '../pages/hotelExtras/EditHotelExtra';
import ProtectedRoute from '../components/global/ProtectedRoute';

const hotelExtrasRoutes = (
    <>
        <Route
            path="/hotel-extras"
            element={
                <ProtectedRoute requiredPermission="hotel_extras_list">
                    <HotelExtras />
                </ProtectedRoute>
            }
        />

        <Route
            path="/hotel-extras/archive"
            element={
                <ProtectedRoute requiredPermission="hotel_extras_archive_list">
                    <HotelExtras />
                </ProtectedRoute>
            }
        />

        <Route
            path="/hotel-extras/create"
            element={
                <ProtectedRoute requiredPermission="hotel_extras_create">
                    <CreateHotelExtra />
                </ProtectedRoute>
            }
        />

        <Route
            path="/hotel-extras/:id/edit"
            element={
                <ProtectedRoute requiredPermission="hotel_extras_edit">
                    <EditHotelExtra />
                </ProtectedRoute>
            }
        />
    </>
);

export default hotelExtrasRoutes;
